import MuiAccordion from "@mui/material/Accordion";
import { styled } from "@mui/material/styles";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px `,
  "&:not(:last-child)": {
    borderBottom: 0
  },
  "&:before": {
    display: "none"
  }
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon />}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    margin: 0
  }

}));
const items = [
  { header: "Review", text: "Our specialists review every aspect of your application to find errors or inconsistencies." },
  { header: "Prepare", text: "Your application will be prepared for submission to the USPTO by trained professionals." },
  { header: "Filing", text: "Your mark will be submitted to the USPTO electronic filing system by our trained team." },
  { header: "Email Delivery", text: "Official updates of your USPTO status are delivered to your via E-mail." },
  { header: "100% Money Back Guarantee", text: "If your mark cannot be filed with the USPTO, we will refund your money, no questions asked." },
  { header: "Trademark Monitoring", text: "1 Month of Free Trademark Monitoring included to ensure no infringements on your mark are filed." },
];

const BasicBox2 = ({ selected, onChange, price }) => {
  return (
    <div className={"package-box2 " + (selected ? "selected" : "")} style={{verticalAlign: "top"}}>
        <h4>&nbsp;</h4>
        <div className="content">
          <h5>Basic</h5>
          <div className="price">${price}</div>
          <p style={{color: "#B8B8B8", fontSize: "12px"}}>+ USPTO fees</p>
          <a onClick={() => onChange("BASIC")}> <div className="getstarted-btn" >Choose Package</div></a>
          <hr />
          {items ? items.map((item, j) => (
            <Accordion className="feature" key={"Accordion" + j} elevation={0}>
              <AccordionSummary key={"AccordionSummary" + j}
                                aria-controls={"panel-content" + j}
                                id={"panel-header" + j}
              >
                <Typography style={{ color: "#7B848D", fontSize: "14px", width: "100%" }}>{item.header}</Typography>
                <CheckCircleOutlineIcon style={{ float: "right", marginRight: "10px", color: "#7B848D" }} />
              </AccordionSummary>
              <AccordionDetails key={"AccordionDetails" + j}>{item.text}</AccordionDetails>
            </Accordion>
          )) : null}
          <a onClick={() => onChange("BASIC")}>  <div className="getstarted-btn" style={{marginTop: "20px", marginBottom: "10px"}} >Choose Package</div>      </a>
        </div>
    </div>
  );
};

export default BasicBox2;
